import {BaseInterface} from './BaseInterface';

export class Internal {

    private errors: BaseInterface[] = null;

    // ########################################

    constructor(
        errors: BaseInterface[]
    ) {
        this.errors = errors;
    }

    // ########################################

    public getErrors(): BaseInterface[] {
        return this.errors;
    }

    // ########################################
}
